import { IPartnerRequest } from 'FeatureModules/Partner/types/partner.types';
import React from 'react';
import { ThemeTypography } from 'DesignSystem';
import CompanyNameLogo from 'Components/CompanyNameLogo';
import { Box } from '@mui/material';
import { EAvailableSizes } from 'DesignSystem/types/size.types';

interface IProps {
  request: IPartnerRequest;
}

const RequestTitle: React.FC<IProps> = ({ request }) => {
  return (
    <Box display="flex" flexWrap="wrap">
      <Box display="flex" mr={1}>
        <CompanyNameLogo
          size={EAvailableSizes.MEDIUM}
          companyName={request.requestedFromCompany.name}
          companyLogoUrl={request.requestedFromCompany.logo?.url}
        />
      </Box>
      <Box whiteSpace="nowrap" display="flex" alignItems="center">
        <ThemeTypography variant="BODY_LARGE_BOLD">
          has requested information from you
        </ThemeTypography>
      </Box>
    </Box>
  );
};

export default RequestTitle;
